import React from "react";
import T from "prop-types";
import { Map } from "immutable";
import _, { isEmpty } from "lodash";
import { DetailTable, Detail } from "MODULES/shared/components/DetailTable";
import { shortDate } from "LIB/formatters/date";
import withCurrentUser, {
  WithCurrentUser
} from "MODULES/session/decorators/withCurrentUser";
import Section from "MODULES/shared/components/Section";
import { INVOICE_NUMBER } from "MODULES/PurchaseOrders/constants";
import { INVOICE_PAID_DATE } from "MODULES/Lots/constants";
import { translateProps } from "MODULES/shared/decorators";
import { decorators } from "@orange-marmalade/paginate-this";
import {
  CORE_REPAIR_INVOICE_NUMBER,
  CORE_REPAIR_INVOICE_PAID,
  EXCHANGE_SALE
} from "MODULES/SalesOrders/constants";

export function Billing({ results, loading }) {
  if (loading) return null;
  const lineItem = results[0];
  if (!lineItem) return null;
  const customerRma = _.get(lineItem, "customer_rmas[0]", null);
  const isFirstExchange =
    (lineItem[EXCHANGE_SALE] && isEmpty(lineItem.exchange_type)) ||
    !isEmpty(lineItem.core_repair_invoice_number);
  return (
    <Section title="Billing" editable={false}>
      <DetailTable>
        <Detail label="Invoice #" value={lineItem[INVOICE_NUMBER]} />
        <Detail
          label="Invoice Paid Date"
          value={shortDate(lineItem[INVOICE_PAID_DATE])}
        />
        {customerRma && (
          <Detail
            label="Customer RMA #"
            value={
              <a
                href={`/rmas/${customerRma.uuid}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {customerRma.code}
              </a>
            }
          />
        )}
        {isFirstExchange && (
          <Detail
            label="Cust. Core Repair Inv#"
            value={lineItem[CORE_REPAIR_INVOICE_NUMBER]}
          />
        )}
        {isFirstExchange && (
          <Detail
            label="Cust. Rpr Inv Paid Date"
            value={shortDate(lineItem[CORE_REPAIR_INVOICE_PAID])}
          />
        )}
      </DetailTable>
    </Section>
  );
}

Billing.propTypes = {
  salesOrder: T.instanceOf(Map).isRequired,
  ...WithCurrentUser
};

const withListId = translateProps(() => ({
  listId: "salesOrders/lineItems"
}));

export default withCurrentUser(withListId(decorators.tabulate(Billing)));



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/Detail/Panel/Billing/Billing.jsx